import type { AuthState } from './auth'

type AuthLifecycleEvent = 'SIGNED_IN' | 'USER_UPDATED' | string

interface SessionUserIdentity {
  id: string
  is_anonymous?: boolean
}

/**
 * Supabase may emit SIGNED_IN repeatedly when an existing session is
 * re-confirmed (for example, when a tab regains focus). Only refresh Martini's
 * profile state when the signed-in identity actually changed. USER_UPDATED
 * remains authoritative for same-user profile/account conversions.
 */
export function shouldRefreshAuthState(
  event: AuthLifecycleEvent,
  sessionUser: SessionUserIdentity | null | undefined,
  currentAuth: AuthState | null,
): boolean {
  if (!sessionUser) return false
  if (event === 'USER_UPDATED') return true
  if (event !== 'SIGNED_IN') return false
  if (!currentAuth) return true

  const accountKindChanged =
    typeof sessionUser.is_anonymous === 'boolean' && currentAuth.isAnonymous !== sessionUser.is_anonymous
  return currentAuth.userId !== sessionUser.id || accountKindChanged
}
